import React, { useEffect, useMemo, useState } from "react";
import "./intro.scss";

import heroImg from "../../assets/HomeLogo.png";

export default function Intro() {
  const roles = useMemo(
    () => [
      "Software Engineer",
      "Full-Stack Developer",
      "Frontend Developer",
      "Backend Developer",
    ],
    []
  );

  const [roleIndex, setRoleIndex] = useState(0);

  useEffect(() => {
    // Rotate roles every 2.2s
    const id = window.setInterval(() => {
      setRoleIndex((prev) => (prev + 1) % roles.length);
    }, 2200);

    return () => window.clearInterval(id);
  }, [roles.length]);

  const scrollToContact = () => {
    const el = document.getElementById("Contact");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section className="intro intro--solid" id="Home">
      <div className="intro__inner">
        <div className="intro__left">
          <h1 className="intro__title">
            Hi, I’m <span className="intro__accent">Sirisha</span>
          </h1>

          <div className="intro__rolePill">
            <span className="intro__bolt">⚡</span>
            <span className="intro__roleLabel">Role:</span>
            <span className="intro__roleText">
              <span className="intro__roleSwap" aria-live="polite">
                <span key={roleIndex} className="intro__roleAnimated">
                  {roles[roleIndex]}
                </span>
              </span>
            </span>
          </div>

          <p className="intro__desc">
            I design and build scalable full-stack systems using cloud-native
            architecture, real-time data pipelines, and production-ready
            engineering.
          </p>

          <div className="intro__actions">
            <button className="intro__cta" onClick={scrollToContact}>
              Contact <span className="intro__arrow">→</span>
            </button>

            <div className="intro__stats">
              <div className="intro__stat">
                <div className="intro__statTop">4+</div>
                <div className="intro__statBottom">Years</div>
              </div>
              <div className="intro__stat">
                <div className="intro__statTop">UI</div>
                <div className="intro__statBottom">+ APIs</div>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT */}
        <div className="intro__right" aria-hidden="true">
          <div className="intro__photoWrap">
            <div className="intro__ring intro__ring--1" />
            <div className="intro__ring intro__ring--2" />
            <div className="intro__ring intro__ring--3" />

            <div className="intro__photo">
              <img src={heroImg} alt="Sirisha" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
